module.exports = __webpack_public_path__ + "img/latte.c5fe4d88.png";